import type { UserTaxInfoApi } from 'api-typings/users/users';
import type { UserTaxInfo } from './user-tax-info.model';

export function transformUserTaxInfo(tax: UserTaxInfoApi): UserTaxInfo {
  const { id, country_code, type, us_tax_subtype, number: tin, name } = tax;

  return {
    id,
    countryCode: country_code,
    type,
    usTaxSubtype: us_tax_subtype,
    number: tin,
    name,
  };
}
